import type { FormInstance, FormProps } from 'antd';

export enum FormFrom {
  Table = 'table',
  Form = 'form',
  Search = 'search',
}
export enum FormMode {
  Edit = 'edit',
  Read = 'read',
}

/**
 * 传递给业务组价你的第二个参数
 */
export interface ColumnRenderConfig {
  /** 当前所在表单类型  */
  from: FormFrom;
  /** 当前字段对应在表单中的字段 */
  name: string | string[];
  /** 当前字段的值 */
  value: any;
  /** 当前数据对应的行，在from=table的时候会存在 */
  rowIndex?: number;
  /** 行数据 */
  rowValue?: any;
  /** 当前表单的完整数据 */
  formValue: any;
  /** 当前页面完整数据 */
  storeValue: any;
  /** 当前对应的模型名 */
  // module: string;
  /** 获取当前模型的数据，可能是头，可能是行 */
  // getModuleValue: () => object | object[];
  // setModuleValue: (value: object | object[]) => void;
  // /** 获取完整的store数据 */
  // getStoreValue: () => object;
  // setStoreValue: (value: object) => void;
  /** 将显示数据注册到session中 */
  setViewValue?: (v: any) => void;
}

export interface Column {
  label?: string;
  /** label候补字段 */
  title?: string;
  name?: string | any[];
  /** name候补字段 */
  dataIndex?: string | any[];
  valueType?: string;
  fieldProps?:
    | object
    | ((form: FormInstance, config: ColumnRenderConfig) => object);
  formItemProps?:
    | object
    | ((form: FormInstance, config: ColumnRenderConfig) => object);
  request?: any;
  requestParams?: object;
  render?: (value: any, config: ColumnRenderConfig, form: FormInstance) => any;
  renderFormItem?: (
    value: any,
    config: ColumnRenderConfig,
    form: FormInstance,
  ) => any;
  style?: object;
  disabled?: boolean;
  required?: boolean;
  visible?: boolean;
  tooltip?: string;
  colProps?: object;
}

export interface SPFormProps extends FormProps {
  columns: Column[] | Array<[string, Column | object]>;
  mode?: FormMode;
  from?: FormFrom;
  /** 表单是否分组 */
  isOpenGroup?: boolean;
  /** 当前表单的值 */
  value?: any;
  rowProps?: object;
  colProps?: object;
  request?: (params: any) => Promise<any>;
  params?: any;
  isMobile?: boolean;
}

export interface SPFormRef extends FormInstance {}

export interface EventType {
  code: string;
  fieldName: string;
  moduleName: string;
  name: string;
  actionType: 'openUrl' | 'copyData';
  touchConfig: 'click' | 'change';
  openType?: 'tab' | 'spa';
  openUrl?: string;
  copyCode?: string;
  copyId?: string;
  copyMap?: Record<string, any>;
}

export interface SPFieldProps extends Column {
  form: any;
  from: FormFrom;
  /** 当前表单的数据 */
  formValue?: any;
  /** Field在表单情况下，需要传入所在行 */
  rowIndex?: number;
  mode?: FormMode;
  labelCol?: object;
  wrapperCol?: object;
  events?: EventType[];
  /** 受控的值 */
  value?: any;
  onChange?: (v: any) => void;
  moduleField?: Record<string, any>;
}
